import { isValid, parseISO } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

export const formatDate = (dateString: string, format: string): string => {
  if (!dateString) return '';

  // First, try to parse the date to validate it
  const parsedDate = parseISO(dateString);

  // Check if the parsed date is valid
  if (!isValid(parsedDate)) {
    console.warn('Invalid date string:', dateString);
    return '';
  }

  // Check if the date string has timezone information
  const timezoneMatch = dateString.match(/([+-]\d{2}:\d{2}|Z)$/);

  let timezone: string;

  if (timezoneMatch) {
    // Has timezone info - extract it
    timezone = timezoneMatch[0] === 'Z' ? 'UTC' : timezoneMatch[0];
  } else {
    // No timezone info - use Polish timezone
    timezone = 'Europe/Warsaw';
  }

  return formatInTimeZone(dateString, timezone, format);
};

export const formatDateWithOffset = (dateString: string, offset: number, format: string): string => {
  if (!dateString) return '';

  const parsedDate = parseISO(dateString);
  if (!isValid(parsedDate)) {
    console.warn('Invalid date string in formatDateWithOffset:', dateString);
    return '';
  }

  if (!offset) return formatInTimeZone(dateString, 'Z', format);

  const hours = Math.floor(Math.abs(offset) / 60);
  const minutes = Math.abs(offset) % 60;
  const sign = offset <= 0 ? '-' : '+';

  const timeZone = `${sign}${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
  return formatInTimeZone(dateString, timeZone, format);
};
